export function capitalize(s) {
  if (typeof s !== "string") return s;
  return s.charAt(0).toUpperCase() + s.slice(1);
}

export function properCase(s) {
  if (typeof s !== "string") return s;
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}

export function clean_special_characters(string, replacementValue = "_") {
  let new_string = string.replace(/[&\\#,+()$~%.'":*?<>{}]/g, replacementValue);
  return new_string;
}
